import React, { useState } from 'react';
import classNames from 'classnames';

import { ICard, ISelectedItemType } from './types';
import { CardStatus } from './constants';

import EmptyBody from './components/EmptyBody';
import FulfilledBody from './components/FulfilledBody';
import Popup from './components/Popup';

import styles from './styles.module.scss';

const CardNav = ({
  active = false,
  defaultImage,
  status = CardStatus.empty,
  selectedItem,
  emptyBodyLabel,
  className,
  isWideImage,
  isMirroredItem,
}: ICard & { isWideImage: boolean } & { isMirroredItem: boolean }) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupItem, setPopupItem] = useState<ISelectedItemType | null>(null);

  const handleHoseClick = () => {
    if (selectedItem) {
      setPopupItem(selectedItem);
      setPopupOpen(true);
    }
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
    setPopupItem(null);
  };

  return (
    <div
      className={classNames(styles.card, className, {
        [styles.active]: active,
      })}
    >
      {status === CardStatus.fulfilled && selectedItem
        ? (
          <>
            <FulfilledBody
              selectedItem={selectedItem}
              defaultImage={defaultImage}
              onClick={handleHoseClick}
              isWideImage={isWideImage}
              isMirroredItem={isMirroredItem}
            />
            <Popup open={popupOpen} onClose={handleClosePopup} item={popupItem || selectedItem} />
          </>
        )
        : emptyBodyLabel && (
          <EmptyBody
            emptyBodyLabel={emptyBodyLabel}
            defaultImage={defaultImage}
          />
        )}
    </div>
  );
};

export default CardNav;
